import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserSessionMagicLinkPost = {
    path: "/user/session/magic-link",
    method: ERouteHttpVerb.POST
};
export { routeLocationUserSessionMagicLinkPost };
